import * as Yup from 'yup';
import { phoneExpression } from '../utility/phone-expression';


const SubpoenaProcessServingDetailsSchema = Yup.object().shape({
    subpoenaProcessServingDetails: Yup.object().shape({
        firstName: Yup.string()
            .required('Required'),
        lastName: Yup.string()
            .required('Required'),
        phone: Yup.string()
            .matches(phoneExpression, 'Invalid phone number'),
    })
});

export default SubpoenaProcessServingDetailsSchema;